export const trimmValue = (value: any) => (value ? value.toString() : '').trim();
